module.exports = __webpack_public_path__ + "img/movie2.8b368e1d.png";